import { Subject } from './Subject';
import { BaseObject } from './BaseObject';
import { Product } from './Product';
import { SubjectCustomer } from './SubjectCustomer';
import { InvoiceDetail } from './InvoiceDetail';
import { EmissionPoint } from './EmissionPoint';
import { Retencion } from './Retencion';
import { NotaCredito } from './NotaCredito';
/*
 * Modelos de datos para armado de factura/proforma
 */
export class Invoice {

    id: number;
    uuid: string;
    description: string;

    emissionOn: Date;
    price: number = 0;
    amount: number = 0;
    subTotal: number = 0.00;
    descuento: number = 0.00;
    subTotalIva0: number = 0.00;
    iva0Total: number = 0.00;
    iva12Total: number = 0.00;
    iva12: boolean = false;
    propina: number = 0.00;
    importeTotal: number = 0.00;//Con Iva
    fechaEmision: string;
    subTotalIva12: number = 0.00;

    subjectCustomer: SubjectCustomer;
    product: Product;

    details: InvoiceDetail[] = [];
    resumen: string;
    
    payments: any[];

    customerId: number;
    customerFullName: string;
    subjectFullName: string;

    //SRI
    estab: string;
    ptoEmi: string;
    emissionPoint: EmissionPoint;

    secuencial: string;
    enviarSRI: boolean;
    accionSRI: string;
    claveAcceso: string;
    internalStatus: string;
    isPayment: boolean;
    tipoFactura: string;

    customerRUC: string;
    customerEmail: string;
    numeroAutorizacion: string;
    authorizationDate: Date;

    //Personalizaciones: metodo de pago y dirección
    paymentMethod: string;
    plazo: number = 0;
    direccion: string;

    camposAdicionales: any[] = [];
    destinatarios: any[] = [];

    notaCredito: NotaCredito = new NotaCredito();
    
    /**
     * Para almacenar en formato json los campos adicionales
     */
    jsonCamposAdicionales:string;
    /**
     * Para almacenar en formato json los destinatarios
     */
    jsonDestinatarios:string;
    
    //Datos para estadística
    pax!:number;
    numeroMesa!:string;
    
    proformaId!:number;
}

/*
 * Modelos de datos para armado de factura/proforma
 */
export class Proforma {

    id: number;
    uuid: string;
    description: string;

    emissionOn: Date;
    price: number = 0;
    amount: number = 0;
    subTotal: number = 0.00;
    descuento: number = 0.00;
    subTotalIva0: number = 0.00;
    iva0Total: number = 0.00;
    iva12Total: number = 0.00;
    iva12: boolean = false;
    propina: number = 0.00;
    importeTotal: number = 0.00;//Con Iva
    fechaEmision: string;
    subTotalIva12: number = 0.00;

    details: InvoiceDetail[] = [];
    resumen: string;

    //SRI
    estab: string;
    ptoEmi: string;
    emissionPoint: EmissionPoint;

    secuencial: string;
    enviarSRI: boolean;
    accionSRI: string;
   
    tipoFactura: string;

    customerRUC: string;
    customerCode: number;
    customerFullName: string;
    customerEmail: string;
    
    subjectFullName: string;
    
    //Personalizaciones: metodo de pago y dirección
    paymentMethod: string;
    plazo: number = 0;
    direccion: string;

    destinatarios: any[] = [];
    
    /**
     * Para almacenar en formato json los destinatarios
     */
    jsonDestinatarios:string;
    
     //Relación en caso de división
    proformaId:number;
    
    subjectCustomer: SubjectCustomer;
}


/*
 * Modelos de datos para armado de factura/proforma
 */
export class Pedido extends Proforma {
   
    //Seguimiento de pagos y ruta de café
    tipoPago!:string;
    tipoPagoCuenta!:string;
    tipoPagoReferencia!:string;
    atendidoPor!:string;
    cobradoPor!:string;
    numeroPasaporteRutaCafe!:string;
    
    internalStatus: string;
    
    //Datos para estadística
    pax!:number;
    mesa!:string;
}